import { Link } from "react-router-dom";
import GpsHeaderMark from "./GpsHeaderMark.jsx";

function Logo({ variant = "header" }) {
  const isLogin = variant === "login";

  if (isLogin) {
    return (
      <div className="gps-logo gps-logo-login" aria-label="GPS">
        <img src="/images/logo3-clean.png" alt="" />
      </div>
    );
  }

  // The two header links have distinct jobs: the GPS logo returns to the PCO
  // Dashboard; the middle title opens Claim Search.
  //
  // No modifier-click handler any more. It used to intercept Ctrl/Cmd/Shift and
  // re-open through window.open so the new tab could be focused; browsers do not
  // permit that (see app/InfoPanel.jsx) and the interception bought nothing over
  // the browser's own behaviour. A plain Link gives the standard background tab
  // on Ctrl+click, which is what everyone expects everywhere else.
  return (
    <Link
      to="/rdr/main"
      className="gps-logo gps-logo-header clickable text-decoration-none"
      aria-label="GPS — go to PCO Dashboard"
      data-hint="PCO Dashboard"
      data-hint-placement="bottom"
    >
      <GpsHeaderMark />
    </Link>
  );
}

export default Logo;
